<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 70vw">
      <div class="modal-header">
        <h5 class="modal-title">Add Scan</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="submitScan">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Test Notes</label>
            <div class="col-sm-10">
              <textarea
                v-model="testNotes"
                style="width: 100%"
                rows="8"
                required
              ></textarea>
            </div>
          </div>

          <fieldset class="form-group">
            <div class="mb-3">
              <label class="form-label">Upload file -- (if any)</label>
              <input
                class="form-control"
                type="file"
                @change="handleFileUpload"
              />
            </div>
          </fieldset>

          <div class="form-group row">
            <div class="col-sm-10">
              <button
                style="float: right"
                type="submit"
                class="btn btn-primary"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiUploadRequest } from "@/api/apiIndex.js";
// , generalApiRequest
export default {
  name: "AddScanModal",
  props: {
    service_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      testNotes: "",
      selectedFile: null,
    };
  },
  methods: {
    closeModal() {
      this.$emit("hide-create-rad-model");
    },
    handleFileUpload(event) {
      this.selectedFile = event.target.files[0];
    },
    async submitScan() {
      const formData = new FormData();
      formData.append("service_id", this.service_id);
      formData.append("note", this.testNotes);
      formData.append("result", ""); // or whatever logic you'd prefer here

      if (this.selectedFile) {
        formData.append("file", this.selectedFile);
      }
      // generalApiUploadRequest(myurl, data, call_class)
      try {
        const response = await generalApiUploadRequest(
          "clinical-results",
          formData,
          1
        );

        if (response.status === "success") {
          location.reload();
          this.closeModal();
        } else {
          alert("Something went wrong.");
        }
      } catch (error) {
        console.error("Submission failed:", error);
        alert("Failed to submit scan result.");
      }
    },
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}
.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
